import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class RightsCon extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        return <div className={styles.privacy} dangerouslySetInnerHTML={{ __html: content.rightsList }} />;
    }
}

export default RightsCon;
